
<template>
  <el-form-item :label="params.label" class="watsonDaterange">
    <el-radio-group
      class="mr8"
      size="small"
      v-model="timeType"
    >
      <el-radio-button label="D">日</el-radio-button>
      <el-radio-button label="w">周</el-radio-button>
      <el-radio-button label="M">月</el-radio-button>
    </el-radio-group>
    <el-date-picker
      :clearable="false"
      size="small"
      v-model="value"
      @change="change"
      :type="timeType === 'w' ? 'week' : timeType === 'D' ? 'date' : 'month'"
      popper-class="datestyle2"
      placeholder="选择日期时间"
      :format="
        timeType === 'w'
          ? 'yyyy 第 WW 周'
          : timeType === 'D'
          ? 'yyyy-MM-dd'
          : 'yyyy-MM'
      "
    >
    </el-date-picker>
  </el-form-item>
</template>

<script>

export default {
  name: 'form-dateselect',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      value: this.dayjs().format('YYYY-MM-DD'),
      timeType: 'M'
    };
  },
  created() {},
  methods: {
    reset() {
      if (this.params.dValue) {
        this.value = this.params.dValue
          ? new Date(this.params.dValue)
          : new Date();
      } else {
        this.value = undefined;
      }
    },
    getValue() {
      console.log(this.value);
      if (this.value) {
        return {
          startTime:this.dayjs(this.value).startOf(this.timeType).format('YYYY-MM-DD HH:mm:ss'),
          endTime:this.dayjs(this.value).endOf(this.timeType).format('YYYY-MM-DD HH:mm:ss')
        }
      }
      return undefined;
    },
    change() {
      const cp = JSON.parse(JSON.stringify(this.params));
      cp.value = this.value;
      this.$emit("csi", cp);
    },
  },
};
</script>

<style lang="less">
@import "../miBicycle.less";
</style>

<style lang="less" scoped>
.mr8{
  margin-right: 8px;
  &+div{
    vertical-align: middle;
  }
}
</style>
